import { combineReducers, configureStore } from "@reduxjs/toolkit";
import thunk from "redux-thunk";
import logger from "redux-logger";
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import authReducer from "../reducers/auth";
import notificationsReducer from "../reducers/notifications";
import profileReducer from "../reducers/profile";
import documentsReducer from "../reducers/documents";
import buyReducer from "../reducers/buy";
import publicationReducer from "../reducers/publication";
import publicationsReducer from "../reducers/publications";
import banksReducer from "../reducers/banks";
import salePostReducer from "../reducers/salePost";
import schedulingReducer from "../reducers/scheduling";
import transactionReducer from "../reducers/transaction";
import termsReducer from "../reducers/terms";
import discountReducer from "../reducers/discount";
import inspectionReducer from "../reducers/inspection";
import leadsReducer from "../reducers/leads";
import colorsReducer from "../reducers/colors";
import brandPublicationReducer from "../reducers/brandPublication";
import massiveChargeReducer from "../reducers/massiveCharge";
import userMiddleware from "./middlewares/userMiddleware";
import { dev } from "./api";
import unauthorizedReducer, { unauthorized } from "../reducers/unauthorized";
import { datadogRum } from "@datadog/browser-rum";

const middlewares = !dev ? [thunk, userMiddleware] : [thunk, logger, userMiddleware];

const persistAuth = {
    key: 'auth',
    storage: storage,
};

const persistColors = {
    key: 'colors',
    storage: storage,
};

const persistedAuthReducer = persistReducer(persistAuth, authReducer);
const persistedColorsReducer = persistReducer(persistColors, colorsReducer);

const appReducer = combineReducers({
    auth: persistedAuthReducer,
    notifications: notificationsReducer,
    profile: profileReducer,
    documents: documentsReducer,
    buy: buyReducer,
    publication: publicationReducer,
    publications: publicationsReducer,
    banks: banksReducer,
    salePost: salePostReducer,
    scheduling: schedulingReducer,
    transaction: transactionReducer,
    terms: termsReducer,
    inspection: inspectionReducer,
    discount: discountReducer,
    leads: leadsReducer,
    colors: persistedColorsReducer,
    brandPublication: brandPublicationReducer,
    massiveCharge: massiveChargeReducer,
    unauthorized: unauthorizedReducer
});

const rootReducer = (state: any, action:any) => {
    if (action.type === unauthorized) {
        // Resetea todo el estado, excepto los reducers persistidos
        const { auth, colors, ...rest } = state;
        state = undefined;
        localStorage.clear()
        setTimeout(() => {
            window.location.reload();
        },300)
    }
    return appReducer(state, action);
};

export const store = configureStore({
    reducer: rootReducer,
    middleware: middlewares,
});
/*
export const store = configureStore({
    reducer: {
        auth: persistedAuthReducer,
        notifications: notificationsReducer,
        profile: profileReducer,
        documents: documentsReducer,
        buy: buyReducer,
        publication: publicationReducer,
        publications: publicationsReducer,
        banks: banksReducer,
        salePost: salePostReducer,
        scheduling: schedulingReducer,
        transaction: transactionReducer,
        terms: termsReducer,
        inspection: inspectionReducer,
        discount: discountReducer,
        leads: leadsReducer,
        colors: persistedColorsReducer,
        unauthorized: unauthorizedReducer
    },
    middleware: middlewares,
});
*/
export const persistor = persistStore(store);
export type StoreState = typeof store;
export type PersitorStoreState = typeof persistor;
export type GetState = typeof store.getState;